export const QUERY_PARAMS = {
  BRAND_NAME: 'brandName',
  SEARCH_TERM: 'searchTerm',
}
